export default __webpack_public_path__ + "static/app-re-dffe49195fff4d20560ab40178e04034.png";